import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 20,
    width: "100%",
  },
  loadingState: {
    minHeight: 360,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px dashed #d4d4d8",
    borderRadius: 16,
    background: "#fff",
    color: "#6b7280",
  },
  editRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    flexWrap: "wrap",
  },
  toggleLabel: {
    fontWeight: 700,
    color: "#111827",
  },
  noteText: {
    color: "#6b7280",
    fontStyle: "italic",
    marginTop: -4,
  },
  statusPanel: {
    borderRadius: 16,
    border: "1px solid #e5e7eb",
    background: "linear-gradient(180deg, #ffffff 0%, #fbfdfb 100%)",
    padding: 18,
    display: "flex",
    flexDirection: "column",
    gap: 14,
    boxShadow: "0 10px 30px rgba(15, 23, 42, 0.04)",
  },
  statusHeaderRow: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 16,
    flexWrap: "wrap",
  },
  sectionTitle: {
    fontWeight: 800,
    color: "#0f172a",
    fontSize: 18,
  },
  sectionSubtitle: {
    color: "#64748b",
    marginTop: 4,
  },
  fieldLabel: {
    fontWeight: 700,
    color: "#111827",
    marginBottom: 8,
  },
  radioGroupWrap: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: 6,
  },
  radioGroup: {
    gap: 10,
    flexWrap: "wrap",
    justifyContent: "flex-end",
    "& .MuiFormControlLabel-label": {
      fontSize: 14,
      color: "#111827",
    },
  },
  statusControlsLocked: {
    opacity: 0.55,
    pointerEvents: "none",
    filter: "grayscale(0.08)",
  },
  sectionDivider: {
    backgroundColor: "#e5e7eb",
  },
  statusToggleRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    flexWrap: "wrap",
  },
  statusSwitch: {
    marginRight: -8,
  },
  verificationPanel: {
    borderRadius: 16,
    border: "1px solid #e5e7eb",
    background: "#ffffff",
    padding: 18,
    display: "flex",
    flexDirection: "column",
    gap: 16,
    boxShadow: "0 10px 30px rgba(15, 23, 42, 0.04)",
  },
  verificationHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 16,
    flexWrap: "wrap",
  },
  verificationTitle: {
    fontWeight: 900,
    color: "#166534",
    letterSpacing: 0.3,
    fontSize: 18,
  },
  verificationSubtitle: {
    color: "#64748b",
    marginTop: 4,
  },
  verifyBtn: {
    borderRadius: 10,
    padding: "9px 16px",
    textTransform: "none",
    fontWeight: 800,
  },
  metricsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
    gap: 12,
    [theme.breakpoints.down("lg")]: {
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    },
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
    },
  },
  metricCard: {
    border: "1px solid #e5e7eb",
    borderRadius: 14,
    padding: 14,
    background: "#fff",
    minHeight: 86,
    display: "flex",
    alignItems: "center",
    gap: 12,
    boxShadow: "0 6px 18px rgba(15, 23, 42, 0.04)",
  },
  metricIcon: {
    width: 40,
    height: 40,
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  metricContent: {
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  metricLabel: {
    fontSize: 11,
    textTransform: "uppercase",
    letterSpacing: 0.4,
    color: "#64748b",
    fontWeight: 800,
  },
  metricValue: {
    fontSize: 24,
    lineHeight: 1.05,
    fontWeight: 900,
    color: "#0f172a",
  },
  metricHelper: {
    fontSize: 12,
    color: "#94a3b8",
  },
  progressWrap: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    width: "100%",
  },
  progressTop: {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "space-between",
    gap: 8,
  },
  progressBar: {
    width: "100%",
    height: 10,
    borderRadius: 999,
    overflow: "hidden",
    background: "#eef2f7",
  },
  warningBanner: {
    borderRadius: 14,
    border: "1px solid #f4c6ca",
    background: "#fff5f6",
    padding: "14px 16px",
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },
  warningBannerHeader: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  warningIconWrap: {
    width: 30,
    height: 30,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#fee2e2",
    flexShrink: 0,
  },
  warningTitle: {
    fontWeight: 800,
    color: "#b42318",
  },
  warningSubtitle: {
    color: "#7f1d1d",
    marginLeft: 40,
  },
  successBanner: {
    borderRadius: 14,
    border: "1px solid #cfe8d2",
    background: "linear-gradient(180deg, #f2fbf4 0%, #edf9ef 100%)",
    padding: "14px 16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    flexWrap: "wrap",
  },
  successBannerHeader: {
    display: "flex",
    alignItems: "flex-start",
    gap: 12,
    flex: 1,
    minWidth: 280,
  },
  successIconWrap: {
    width: 30,
    height: 30,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#dcfce7",
    flexShrink: 0,
  },
  successTitle: {
    fontWeight: 800,
    color: "#11823b",
  },
  successSubtitle: {
    color: "#56745e",
    marginTop: 2,
    maxWidth: 620,
  },
  successActions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: 6,
    minWidth: 240,
    [theme.breakpoints.down("sm")]: {
      alignItems: "stretch",
      width: "100%",
      minWidth: 0,
    },
  },
  approvalToggle: {
    marginRight: 0,
    "& .MuiFormControlLabel-label": {
      color: "#111827",
      fontSize: 13,
      fontWeight: 700,
    },
  },
  tableWrapper: {
    borderRadius: 14,
    overflow: "hidden",
    border: "1px solid #e5e7eb",
    background: "#fff",
  },
  dataGridTable: {
    width: "100%",
    border: 0,
    "& .MuiDataGrid-root": {
      border: 0,
    },
    "& .MuiDataGrid-columnHeaders": {
      background: "#eaf6ee",
      borderBottom: "1px solid #dce9de",
      minHeight: "54px !important",
      maxHeight: "54px !important",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 900,
      textTransform: "uppercase",
      fontSize: 12,
      color: "#166534",
      letterSpacing: 0.35,
    },
    "& .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-cell": {
      borderBottom: "1px solid #eef2f7",
      outline: "none !important",
      paddingTop: 10,
      paddingBottom: 10,
      alignItems: "center",
    },
    "& .MuiDataGrid-row:hover": {
      background: "#fbfdfc",
    },
    "& .MuiDataGrid-virtualScroller": {
      overflowX: "hidden",
    },
    "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-footerContainer": {
      display: "none",
    },
  },
  documentCell: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    minWidth: 0,
  },
  documentIcon: {
    width: 34,
    height: 34,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#edf4ff",
    color: "#2563eb",
    flexShrink: 0,
  },
  documentName: {
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.2,
  },
  documentAlias: {
    color: "#64748b",
    lineHeight: 1.2,
  },
  detailText: {
    color: "#475569",
    lineHeight: 1.3,
  },
  rowActionButton: {
    textTransform: "none",
    fontWeight: 800,
    paddingInline: 8,
    whiteSpace: "nowrap",
  },
  emptyState: {
    padding: 32,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#64748b",
    background: "#fff",
  },
  creationPanel: {
    borderRadius: 14,
    border: "1px solid #f1c0c7",
    background: "#fff6f7",
    padding: 16,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    flexWrap: "wrap",
  },
  creationText: {
    display: "flex",
    alignItems: "flex-start",
    gap: 12,
    flex: 1,
    minWidth: 280,
  },
  creationIcon: {
    width: 40,
    height: 40,
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#fee2e2",
    color: "#b42318",
    flexShrink: 0,
  },
  creationTitle: {
    fontWeight: 900,
    color: "#b42318",
  },
  creationSubtitle: {
    color: "#7f1d1d",
    marginTop: 2,
  },
  creationActions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: 6,
    minWidth: 240,
    [theme.breakpoints.down("sm")]: {
      alignItems: "stretch",
      width: "100%",
      minWidth: 0,
    },
  },
  createAccountBtn: {
    minWidth: 240,
    borderRadius: 12,
    textTransform: "none",
    fontWeight: 900,
    padding: "10px 18px",
    background: "#d7d7d7",
    color: "#6b7280",
    "&.Mui-disabled": {
      background: "#d7d7d7",
      color: "#7a7a7a",
    },
  },
  creationNote: {
    color: "#7f1d1d",
  },
  infoBanner: {
    borderRadius: 12,
    border: "1px solid #d4e2fb",
    background: "#f7fbff",
    padding: "12px 14px",
    display: "flex",
    alignItems: "flex-start",
    gap: 12,
  },
  infoIconWrap: {
    width: 30,
    height: 30,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#e0ecff",
    flexShrink: 0,
  },
  infoTitle: {
    fontWeight: 800,
    color: "#2563eb",
  },
  infoSubtitle: {
    color: "#4b6b8a",
    marginTop: 2,
  },
})); 

export default useStyles;
